import { useState } from 'react';
import { useAuthStore } from '@/store/authStore';
import { RegisterFormData } from '../types';
import { validatePhoneNumber } from '@/utils/validation';
import { validateRegistrationPhone } from '@/utils/validation/registerValidation';

export function useRegisterForm() {
  const { addRegisterRequest } = useAuthStore();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const onSubmit = async (data: RegisterFormData) => {
    if (isSubmitting) return false;

    // Validate phone number format
    const phoneValidation = validatePhoneNumber(data.phoneNumber);
    if (phoneValidation !== true) {
      setError(typeof phoneValidation === 'string' ? phoneValidation : 'رقم الهاتف غير صحيح');
      return false;
    }

    // Validate registration eligibility
    const registrationValidation = validateRegistrationPhone(data.phoneNumber);
    if (!registrationValidation.isValid) {
      setError(registrationValidation.message || 'خطأ في التحقق من رقم الهاتف');
      return false;
    }

    setIsSubmitting(true);
    try {
      const request = {
        id: Math.random().toString(36).substr(2, 9),
        status: 'pending' as const,
        timestamp: Date.now(),
        data
      };
      
      addRegisterRequest(request);
      setIsSuccess(true);
      setError(null);
      return true;
    } catch (error) {
      console.error('Error submitting registration:', error);
      setError('حدث خطأ أثناء تقديم الطلب');
      return false;
    } finally {
      setIsSubmitting(false);
    }
  };

  return {
    onSubmit,
    isSubmitting,
    isSuccess,
    error
  };
}